"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalMode = void 0;
var PortalMode;
(function (PortalMode) {
    PortalMode["KSC_CC"] = "KscCC";
    PortalMode["NEXT"] = "Next";
})(PortalMode || (exports.PortalMode = PortalMode = {}));
